var sharedNode;

function getSharedNode() {
  if (!sharedNode) {
    sharedNode = window.document.createElement('div');
    sharedNode.style.position = 'fixed';
    sharedNode.style.top = '-1000px';
    sharedNode.style.visibility = 'hidden';
    sharedNode.style.width = 'auto';
    sharedNode.style.height = 'auto';
    sharedNode.style.zIndex = '-1';
    window.document.body.appendChild(sharedNode);
  }

  return sharedNode;
}

export function getTextRect(text, className) {
  var node = getSharedNode();
  node.className = className || '';
  node.textContent = text;
  return node.getBoundingClientRect();
}